@if (simpleTestingGroup) {
    <div [formGroup]="simpleTestingGroup">
        <div class="form-group">
            <label for="catalogueSelect">
                {{ 'controls.simpleTestingTestPlan.catalogueLabel' | transloco: { required: type == SimpleTestingType.DesignImplementation ? '*' : '' } }}
            </label>
            <ng-select
                id="catalogueSelect"
                name="catalogueSelect"
                [items]="standingData.Catalogues"
                (change)="catalogueChanged.emit($event)"
                formControlName="Catalogue"
                bindLabel="Name"
                bindValue="ID"
                [placeholder]="type == SimpleTestingType.DesignImplementation ? 'Required' : ''"
            >
            </ng-select>
        </div>
        <div class="form-group-separator"></div>

        <div class="row">
            <div class="col-12 col-xl-6 left-block">
                <div class="row">
                    <div class="form-group col-6">
                        <label for="testersSelect">{{ 'controls.simpleTestingTestPlan.testersLabel' | transloco }}</label>
                        <ng-select
                            id="testersSelect"
                            name="testersSelect"
                            [items]="standingData.Testers"
                            formControlName="Testers"
                            bindLabel="Name"
                            bindValue="ID"
                            [multiple]="true"
                            [placeholder]="'controls.simpleTestingTestPlan.requiredPlaceholder' | transloco"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                    <div class="form-group col-6">
                        <label for="evidenceUploadersSelect">{{ 'controls.simpleTestingTestPlan.evidenceUploadersLabel' | transloco }}</label>
                        <ng-select
                            id="evidenceUploadersSelect"
                            name="evidenceUploadersSelect"
                            [items]="standingData.EvidenceUploaders"
                            formControlName="EvidenceUploaders"
                            bindLabel="Name"
                            bindValue="ID"
                            [multiple]="true"
                            [placeholder]="'controls.simpleTestingTestPlan.requiredPlaceholder' | transloco"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <label>{{ 'controls.simpleTestingTestPlan.initialTestDateLabel' | transloco }}</label>
                        <date-input formControlName="InitialTestDate"></date-input>
                    </div>
                    <div class="form-group col-6">
                        <label for="uploaderDueDateInput"
                            >{{ 'controls.simpleTestingTestPlan.uploaderDueDateLabel' | transloco }}
                            <i
                                class="far fa-question-circle ms-2"
                                [matTooltip]="'controls.simpleTestingTestPlan.uploaderDueDateTooltip' | transloco"
                            ></i>
                        </label>
                        <input
                            type="number"
                            class="form-control form-control-sm"
                            id="uploaderDueDateInput"
                            name="uploaderDueDateInput"
                            formControlName="UploaderDueDate"
                        />
                        @if (simpleTestingGroup.controls.UploaderDueDate.errors) {
                            <div class="red">
                                @if (simpleTestingGroup.controls.UploaderDueDate.errors.min) {
                                    <p>{{ 'controls.simpleTestingTestPlan.cannotBeNegative' | transloco }}</p>
                                }
                            </div>
                        }
                    </div>
                </div>

                <div class="form-group-separator"></div>

                <div class="row">
                    <div class="form-group col-6">
                        <label for="linkedStandardSelect">{{ 'controls.simpleTestingTestPlan.linkedStandardLabel' | transloco }}</label>
                        <ng-select
                            id="linkedStandardSelect"
                            name="linkedStandardSelect"
                            [items]="standingData.LinkedStandards"
                            formControlName="LinkedStandard"
                            bindLabel="Name"
                            bindValue="ID"
                        >
                        </ng-select>
                    </div>
                    <div class="form-group col-6">
                        <label for="testSamplesInput">{{ 'controls.simpleTestingTestPlan.testSamplesLabel' | transloco }}</label>
                        <input
                            type="number"
                            class="form-control form-control-sm"
                            id="testSamplesInput"
                            name="testSamplesInput"
                            formControlName="TestSamples"
                        />
                        @if (simpleTestingGroup.controls.TestSamples.errors) {
                            <div class="red">
                                @if (simpleTestingGroup.controls.TestSamples.errors.min) {
                                    <p>{{ 'controls.simpleTestingTestPlan.cannotBeNegative' | transloco }}</p>
                                }
                            </div>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <label for="qualityAspectSelect">{{ 'controls.simpleTestingTestPlan.qualityAspectLabel' | transloco }}</label>
                        <ng-select
                            id="qualityAspectSelect"
                            name="qualityAspectSelect"
                            [items]="standingData.QualityAspects"
                            formControlName="QualityAspect"
                            bindLabel="Name"
                            bindValue="ID"
                            [multiple]="true"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                    <div class="form-group col-6">
                        <label for="testFrequencySelect">{{ 'controls.simpleTestingTestPlan.testFrequencyLabel' | transloco }}</label>
                        <ng-select
                            id="testFrequencySelect"
                            name="testFrequencySelect"
                            [items]="standingData.TestFrequencies"
                            formControlName="TestFrequency"
                            bindLabel="Name"
                            bindValue="ID"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-6 right-block">
                <div class="row">
                    <div class="form-group col">
                        <cerrix-textarea
                            [fieldLabel]="'controls.simpleTestingTestPlan.testActivityLabel' | transloco"
                            identifier="testActivityInput"
                            [rows]="7"
                            formControlName="TestActivity"
                        ></cerrix-textarea>
                    </div>
                </div>
                <div class="form-group-separator"></div>
                <div class="row">
                    <div class="form-group col">
                        <cerrix-textarea
                            [fieldLabel]="'controls.simpleTestingTestPlan.testNormLabel' | transloco"
                            identifier="testNormInput"
                            [rows]="7"
                            formControlName="TestNorm"
                        ></cerrix-textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
